<div class="categories-section">
  <div class="container">
    <div class="categories-nav-wrapper">
      <div class = "nav-arrow-container" *ngIf="showCategoryButtons && categories.length > 0">
        <button class="nav-arrow" [ngClass] = "{'disabled' : !enableLeftCategoryButton}" (click)="scrollLeft('categories')">
          <fa-icon [icon]="faArrowLeft"></fa-icon>
        </button>
      </div>
      
      <div 
      class="categories-container"
      #categoriesContainer
      [style.padding] = "categories.length > 0 ? '10px 0px' : '0px'">
        <div class="categories-grid">
          <div
            *ngFor="let category of categories"
            class="category-card"
            (click)="selectCategory(category._id)"
            [ngClass] = "{'custom-height' : showCategoryImage, 'active': category._id == selectedCategory}"
          >
            <div
              class="category-image-container"
              *ngIf="showCategoryImage"
            >
              <img [src]="category.image" class = "category-image" [alt]="category.name" />
            </div>
            <div class="category-name">
              <span>{{ category.name }}</span>
            </div>
            
          </div>
        </div>
      </div>

      <div class = "nav-arrow-container" *ngIf="showCategoryButtons && categories.length > 0">
        <button class="nav-arrow" [ngClass] = "{'disabled' : !enableRightCategoryButton}" (click)="scrollRight('categories')">
          <fa-icon [icon]="faArrowRight"></fa-icon>
        </button>
      </div>
    </div>

    <div class="categories-nav-wrapper subcategory-wrapper" *ngIf="showSubcategories">
      <div class = "nav-arrow-container" *ngIf="showSubcategoryButtons && subcategories.length > 0">
        <button class="nav-arrow" [ngClass] = "{'disabled' : !enableLeftSubcategoryButton}" (click)="scrollLeft('subcategories')">
          <fa-icon [icon]="faArrowLeft"></fa-icon>
        </button>
      </div>
      
      <div class="categories-container" #subcategoriesContainer>
        <div class="categories-grid">
          <div
            *ngFor="let subcategory of subcategories"
            class="subcategory-card"
            [ngClass] = "{'active': subcategory?._id == selectedSubcategory}"
            (click)="selectSubcategory(subcategory?._id)"
          >
          
            <div
              class="subcategory-image-container"
              [ngClass] = "{'active': subcategory?._id == selectedSubcategory}"
            >
              <img
              [src]="subcategory?.image || 'assets/images/placeholder.png'"
              class = "subcategory-image"
              [alt]="subcategory?.name"
              />
            </div>
            <div class="subcategory-name" [ngClass] = "{'active': subcategory?._id == selectedSubcategory}">
              <span>{{ subcategory?.name }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class = "nav-arrow-container" *ngIf="showSubcategoryButtons && subcategories.length > 0">
        <button class="nav-arrow" [ngClass] = "{'disabled' : !enableRightSubcategoryButton}" (click)="scrollRight('subcategories')">
          <fa-icon [icon]="faArrowRight"></fa-icon>
        </button>
      </div>
    </div>
  </div>
</div>
